import { Checkbox as ChakraCheckbox } from '@chakra-ui/react'
import * as React from 'react'

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  /** Replaces the default check / indeterminate indicator. */
  icon?: React.ReactNode
  /** Props forwarded to the hidden native `<input type="checkbox">`. */
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  /** Ref for the root `<label>` element. The forwarded ref targets the input. */
  rootRef?: React.Ref<HTMLLabelElement>
}

const filledControlStyles = {
  bg: 'colorPalette.solid',
  borderColor: 'colorPalette.solid',
}

/**
 * Brand-styled checkbox. Checked and indeterminate controls use
 * `colorPalette.solid` / `colorPalette.contrast`, with `colorPalette`
 * defaulting to `brand`.
 */
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  function Checkbox(props, ref) {
    const { icon, children, inputProps, rootRef, ...rest } = props
    return (
      <ChakraCheckbox.Root ref={rootRef} colorPalette="brand" {...rest}>
        <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
        <ChakraCheckbox.Control
          borderWidth="2px"
          borderColor="border.default"
          bg="bg.default"
          flexShrink={0}
          _hover={{ borderColor: 'border.emphasized' }}
          _checked={filledControlStyles}
          _indeterminate={filledControlStyles}
        >
          {icon || <ChakraCheckbox.Indicator color="colorPalette.contrast" />}
        </ChakraCheckbox.Control>
        {children != null && (
          <ChakraCheckbox.Label ms={2}>{children}</ChakraCheckbox.Label>
        )}
      </ChakraCheckbox.Root>
    )
  },
)
